const mapFaqToSeo = (faqList) => {
  return faqList.map((faq) => ({
    questionName: faq.title,
    acceptedAnswerText: faq.description,
  }));
};

export default mapFaqToSeo;
